module.exports = __webpack_public_path__ + "img/tribe-uncommon.d7a3b2f5.svg";